import { render, staticRenderFns } from "./gchart2.vue?vue&type=template&id=3960986c&scoped=true&"
import script from "./gchart2.vue?vue&type=script&lang=js&"
export * from "./gchart2.vue?vue&type=script&lang=js&"
import style0 from "./gchart2.vue?vue&type=style&index=0&id=3960986c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3960986c",
  null
  
)

export default component.exports